"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShareCartState = /** @class */ (function () {
    function ShareCartState() {
        this.displayLinkCopiedText = false;
        this.showShareCartModal = false;
    }
    return ShareCartState;
}());
exports.default = ShareCartState;
//# sourceMappingURL=ShareCartState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/ShareCart/ShareCartState.js
// module id = 2338
// module chunks = 8